<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form" :model="formData" :rules="rules" ref="form" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="bidTitle" label="标题">
              <el-input v-model="formData.bidTitle" placeholder="请输入标题"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="purchaser" label="采购方">
              <el-select v-model="formData.purchaser" clearable filterable placeholder="请选择采购方">
                <el-option v-for="(item) of userList" :value="item.userId" :label="item.userName"
                  :key="item.userId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-form-item prop="specList" label="规格">
            <el-button class="mb15" type="primary" @click="addSpecList">新增规格</el-button>
            <el-table :data="formData.specList">
              <!-- <el-table-column prop="" label="采购类型">
                <template v-slot="{ row, $index }">
                  <el-form-item :prop="`specList.${$index}.purchaseType`"
                    :rules="[{ required: true, message: '请选择采购类型' }]">
                    <el-select v-model="row.purchaseType" clearable @change="res => changeType(row, res)" filterable
                      placeholder="请选择采购类型">
                      <el-option v-for="(item) of typeArr" :value="item.value" :label="item.label"
                        :key="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </template>
</el-table-column> -->
              <el-table-column prop="specId" label="规格">
                <template v-slot="{ row, $index }">
                  <el-form-item :prop="`specList.${$index}.specId`" :rules="[{ required: true, message: '请选择规格' }]">
                    <el-input readonly v-model="row.specName" @click.native="onSpecShow(row, onFormDataSpecChange)"
                      placeholder="请选择品种规格" />
                    <!-- <el-select v-model="row.specId" clearable filterable
                      :placeholder="row.purchaseType ? '请选择规格' : '请先选择采购类型'"
                      :disabled="row.purchaseType ? false : true">
                      <el-option v-for="(item, index) of row.specList"
                        :value="row.purchaseType == '1' ? item.specId : item.materialId"
                        :label="row.purchaseType == '1' ? item.specName : item.materialName" :key="index"></el-option>
                    </el-select> -->
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="deliveryPrice" label="暂定单价/结算单价">
                <template v-slot="{ row, $index }">
                  <el-form-item :prop="`specList.${$index}.deliveryPrice`"
                    :rules="[{ required: true, message: '请输入暂定单价/结算单价' }]">
                    <el-input v-model="row.deliveryPrice" placeholder="请输入暂定单价/结算单价" />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="basisPrice" label="基差价格">
                <template v-slot="{ row, $index }">
                  <el-form-item :prop="`specList.${$index}.basisPrice`"
                    :rules="[{ required: true, message: '请输入基差价格' }]">
                    <el-input v-model="row.basisPrice" placeholder="请输入基差价格" />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="purchaseQuantity" label="订单数量">
                <template v-slot="{ row, $index }">
                  <el-form-item :prop="`specList.${$index}.purchaseQuantity`"
                    :rules="[{ required: true, message: '请输入订单数量' }]">
                    <el-input-number v-model="row.purchaseQuantity" />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template v-slot="{ $index }">
                  <el-button class="del-btn" type="text" @click="deleteSpec($index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="bidStart" label="招标开始日期">
              <el-date-picker v-model="formData.bidStart" :picker-options="pickerOptions1" placeholder="请选择招标开始日期"
                type="date" clearable format="yyyy-MM-dd" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="bidEnd" label="招标截至日期">
              <el-date-picker v-model="formData.bidEnd" :picker-options="pickerOptions2" placeholder="请选择招标截至日期"
                type="date" clearable format="yyyy-MM-dd" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="supplierList" label="供应商">
              <el-select v-model="formData.supplierList" clearable multiple filterable placeholder="请选择供应商">
                <el-option v-for="(item) of supplierList" :value="item.userId" :label="item.userName"
                  :key="item.userId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="invoiceReq" label="发票要求">
              <el-input type="textarea" :autosize="{ minRows: 3 }" placeholder="请输入发票要求" v-model="formData.invoiceReq">
              </el-input>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="deliveryReq" label="发货要求">
              <el-input type="textarea" :autosize="{ minRows: 3 }" placeholder="请输入发货要求" v-model="formData.deliveryReq">
              </el-input>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="paymentReq" label="账期要求">
              <el-input type="textarea" :autosize="{ minRows: 3 }" placeholder="请输入账期要求" v-model="formData.paymentReq">
              </el-input>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="qualityReq" label="质量要求">
              <el-input type="textarea" :autosize="{ minRows: 3 }" placeholder="请输入质量要求" v-model="formData.qualityReq">
              </el-input>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="remark" label="备注说明">
              <el-input type="textarea" :autosize="{ minRows: 3 }" placeholder="请输入备注说明" v-model="formData.remark">
              </el-input>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="附件" prop="fileList">
              <file-upload v-model="formData.fileList" :maxSize="20"></file-upload>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>

              <el-button type="primary" @click="submit">保存</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>

    <SpecChoose :visible.sync="dialogVisible" @select="onSpecSelect"></SpecChoose>

  </div>
</template>

<script>
import { deepClone } from '../../utils/utils'
import SpecChoose from '@/components/SpecChoose.vue'
export default {
  name: 'TenderDocumentAdd',
  components: {
    SpecChoose
  },
  data() {
    return {
      userList: [],
      specList: [],
      supplierList: [],
      formData: {
        bidTitle: '', // 标题
        purchaser: '', // 采购方
        bidStart: '', // 招标开始时间
        bidEnd: '', // 招标截至时间
        status: '', // 状态1招标中2评标中3已中标4已废标
        invoiceReq: '', // 发票要求
        // purchaseType: '', // 采购类型1粮油2物料
        deliveryReq: '', // 发货要求
        remark: '', // 备注说明
        paymentReq: '', // 账期要求
        qualityReq: '', // 质量要求
        fileList: [], // 附件列表
        supplierList: [], // 供应商列表
        specList: [] // 规格列表
      },
      rules: {
        bidTitle: [{ required: true, message: '请输入标题', trigger: 'change' }],
        purchaser: [{ required: true, message: '请输入采购方', trigger: 'change' }],
        specList: [{ required: true, type: 'array', message: '请添加规格' }],
        bidStart: [{ required: true, message: '请选择招标开始日期', trigger: 'change' }],
        bidEnd: [{ required: true, message: '请选择招标截至日期', trigger: 'change' }],
        invoiceReq: [{ required: true, message: '请输入发票要求', trigger: 'blur' }],
        deliveryReq: [{ required: true, message: '请输入发货要求', trigger: 'blur' }],
        paymentReq: [{ required: true, message: '请输入账期要求', trigger: 'blur' }],
        qualityReq: [{ required: true, message: '请输入质量要求', trigger: 'blur' }],
        supplierList: [{ required: true, type: 'array', message: '请选择供应商', trigger: 'change' }]
      },
      dialogVisible: false,
      currentRow: {},
      callback: null,
      // 1粮油2物料
      typeArr: [
        {
          label: '粮油',
          value: '1'
        },
        {
          label: '物料',
          value: '2'
        }
      ],
      // 1招标中2评标中3已中标4已废标
      statusArr: [
        {
          label: '招标中',
          value: '1'
        },
        {
          label: '评标中',
          value: '2'
        },
        {
          label: '已中标',
          value: '3'
        },
        {
          label: '已废标',
          value: '4'
        }
      ],
      pickerOptions1: {
        disabledDate: (time) => {
          if (this.formData.bidEnd) {
            return time.getTime() > new Date(this.formData.bidEnd).getTime()
          }
        }
      },
      pickerOptions2: {
        disabledDate: (time) => {
          if (this.formData.bidStart) {
            return time.getTime() < (new Date(this.formData.bidStart).getTime() - 8.64e7)
          }
        }
      }
    }
  },
  created() {
    this.loadSupplierList()
    this.loadUserList()
    if (this.bidId) {
      this.loadData()
    }
  },
  computed: {
    bidId() {
      return this.$route.query.bidId
    }
  },
  methods: {
    onSpecShow(row, callback) {
      this.dialogVisible = true
      this.currentRow = row
      this.callback = callback
    },
    onSpecSelect(data) {
      this.callback(this.currentRow, data)
    },
    onFormDataSpecChange(row, data) {
      row.specName = data.specName
      row.specId = data.specId
    },
    loadUserList() {
      this.$axios.get(this.$apis.system.selectSysUserByPage, {
        userType: '2,3,4'
      }).then(res => {
        this.userList = res.list || []
      })
    },
    addSpecList() {
      const row = {
        specId: '', // 规格id
        specName: '', // 规格名称
        deliveryPrice: '', // 暂定单价/结算单价
        basisPrice: '', // 基差价格
        purchaseQuantity: '', // 订单数量
        purchaseType: '' // 采购类型1粮油2物料
      }
      this.formData.specList.push(row)
    },
    deleteSpec(index) {
      this.formData.specList.splice(index, 1)
    },
    loadSupplierList() {
      this.$axios.get(this.$apis.common.selectIparkUserByList, { userType: '4' }).then(res => {
        this.supplierList = res || []
      })
    },
    loadData() {
      this.$axios.get(this.$apis.tenderDocument.selectYcBidDocumentByBidId, {
        params: { bidId: this.bidId }
      }).then(async res => {
        res.fileList = res.fileList ? res.fileList : []
        res.supplierList = res.supplierList ? res.supplierList.map(item => item.supplierId) : []
        this.formData = res || {}
      })
    },

    submit() {
      this.$refs.form.validate().then(() => {
        let url = this.$apis.tenderDocument.insertYcBidDocument
        if (this.bidId) {
          url = this.$apis.tenderDocument.updateYcBidDocument
        }
        const tempForm = deepClone(this.formData)
        const supplierList = this.formData.supplierList.map(item => {
          return { supplierId: item }
        })
        tempForm.supplierList = supplierList
        this.$axios.post(url, tempForm).then(() => {
          this.$router.back()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-date-editor {
    width: 100%;
    max-width: 400px;

  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
